import 'babel-polyfill';
import { instance } from '../utils/axiosInstance'


export class QrApi {
    static async getQrs() {
        return instance.get('/qrs');
    }
    static async createQr(qrData){
        return instance.post('/qr', qrData)
    }
    static async deleteQr(qrId){
        return instance.delete('/qr/' + qrId)
    }
    static async purgeQrs(){
        return instance.delete('/qrs')
    }
}



// WEBPACK FOOTER //
// ./src/api/qrApi.js